import React from "react";
import type { PinnedLink } from "../pins/pinnedLinks";

/**
 * Fachlicher Pin der aktuell geöffneten Seite.
 *
 * Seiten mit eigenem Objektbezug (z. B. eine Personenakte) melden hier ihren Pin an, damit der
 * Pin-Knopf für ALLE Seiten an derselben Stelle in der Titelleiste sitzt und trotzdem
 * Name und Foto statt eines generischen Routentitels speichert. Ohne Anmeldung fällt der
 * Knopf auf die Auflösung über Menü und Seitenkataloge zurück.
 */
type LayoutPagePinContextValue = {
  setPagePin: (pin: PinnedLink | null) => void;
};

export const LayoutPagePinContext = React.createContext<LayoutPagePinContextValue>({
  setPagePin: () => {}
});

/**
 * Meldet den Pin der aktuellen Seite an die Titelleiste an und räumt ihn beim Verlassen ab.
 * `null` übergeben, solange die Daten noch laden.
 */
export function useSetPagePin(pin: PinnedLink | null): void {
  const { setPagePin } = React.useContext(LayoutPagePinContext);

  // Der Pin wird typischerweise inline gebaut; über den Inhalt vergleichen, damit
  // nicht jeder Render des aufrufenden Bildschirms den Layout-State neu setzt.
  const serialized = pin ? JSON.stringify(pin) : null;

  React.useEffect(() => {
    setPagePin(serialized ? (JSON.parse(serialized) as PinnedLink) : null);
    return () => setPagePin(null);
  }, [serialized, setPagePin]);
}
